import { Injectable, inject } from '@angular/core';
import { NotificationService, NotificationServiceInjector } from '@next/core-lib/notification';
import { createEffect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { filter, withLatestFrom } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { SiteState } from 'src/app/shared/models';

import { GetOrganicMatterReport } from 'src/app/store/actions';
import { selectCropFieldAdvices } from 'src/app/store/selectors';

import {
  CompletedGenerateOrganicMatterBalance,
  OrganicMatterBalanceEvents,
} from '../organic-matter.models';

@Injectable()
export class OrganicMatterBalanceEffects {
  private readonly notification = inject<NotificationService>(NotificationServiceInjector);
  private readonly store = inject<Store<SiteState>>(Store);

  completedGenerateOrganicMatterBalance$ = createEffect(() =>
    this.notification
      .on<CompletedGenerateOrganicMatterBalance>(
        OrganicMatterBalanceEvents.CompletedGenerateOrganicMatterBalance,
      )
      .pipe(
        withLatestFrom(this.store.pipe(select(selectCropFieldAdvices))),
        filter(([, report]) => report != null),
        map(
          ([_, cropFieldAdvices]) =>
            new GetOrganicMatterReport(cropFieldAdvices.map((c) => c.cropFieldId)),
        ),
      ),
  );
}
